import { api } from './client';
import { GallerySort, GalleryTypeFilter, Image } from '../types/entities/image.entity';
import { ImagesResponse } from '../types/responses/images.responses.ts';

export interface ImageListParams {
    page?: number;
    perPage?: number;
    type?: GalleryTypeFilter;
    sort?: GallerySort;
    albumId?: string;
}

const buildListQuery = ({ page = 1, perPage, type, sort, albumId }: ImageListParams): string => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    if (perPage != null) {
        params.set('per_page', String(perPage));
    }
    if (type && type !== 'all') {
        params.set('type', type);
    }
    if (sort) {
        params.set('sort', sort);
    }
    if (albumId) {
        params.set('album_id', albumId);
    }
    return params.toString();
};

export const imageService = {
    getAll: async (params: ImageListParams = {}) => {
        const response = await api.get<ImagesResponse>(`/images?${buildListQuery(params)}`);
        return response.data;
    },

    upload: async (files: File[], albumId?: string | null) => {
        const formData = new FormData();
        files.forEach((file, index) => {
            formData.append(`images[${index}]`, file);
        });
        if (albumId) {
            formData.append('album_id', albumId);
        }

        const response = await api.post<{ data: Image[] }>('/images', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    delete: async (id: string) => {
        await api.delete(`/images/${id}`);
    },

    updateDisplayName: async (id: string, displayName: string) => {
        const response = await api.put<{ data: { image: Image } }>(`/images/${id}`, {
            display_name: displayName,
        });
        return response.data;
    },
};
